<style scoped>
.mainTopBar {
  height: 52px;
  background: #29e;
  position: relative;
  z-index: 1000;
}

.mainTopBar {
  font-size: 14px;
  color: #fff;
}

.companyName {
  height: 52px;
  line-height: 52px;
  position: relative;
  padding-right: 25px;
}

.company-name {
  display: inline-block;
  max-width: 90%;
  padding-left: 12px;
  overflow: hidden;
  vertical-align: top;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.b {
  border: 1px solid red;
}

.infoGroup {
  width: 230px;
  padding-right: 12px;
  position: absolute;
  right: 0;
  top: 0;
  height: 52px;
  color: white;
  line-height: 52px;
}

.container-left {
  background: white;
  width: 230px;
  height: 100%;
  min-height: 200px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 98;
  overflow: hidden;
  overflow-y: auto;
  border-right: 1px solid #ccc;
}

.approve-container {
  background: white;
}

.container-right {
  margin-left: 230px;
  height: 100%;
  min-width: 772px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 96;
  overflow: hidden;
}
</style>

<template>
  <div>
    <TopMain>
      <div slot="header">
        <div class="mainTopBar">
          <!-- 左边Bananer -->
          <div class="companyWrap">
            <div class="companyName">
              <span class="company-name enterprise-state">自动搭建postfix邮局</span>

            </div>
          </div>
          <!-- 右边Bananer -->
          <div class="infoGroup">
            <div style="position: absolute;right:8px">
              <Dropdown @on-click="loginout">
                <span style="cursor:pointer">{{ this.$storage.getSession('uid') }}</span>
                <Icon type="ios-arrow-down"></Icon>
                <DropdownMenu slot="list">
                  <DropdownItem name="updatepassword">修改密码</DropdownItem>
                  <DropdownItem name="loginout">退出登陆</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <div slot="main" style="min-height:100%">
        <div class="container-left">

          <div style="padding:10px;">
            <Button size="long" type="primary" style="background-color: #41ABF6;border:none">刷新</Button>
          </div>

          <Menu active-name="/client" :open-names="['1']" @on-select="reurl">
            <MenuItem name="/client">
              平台列表
            </MenuItem>
            <MenuItem name="/Outboxs">
              发件箱生成
            </MenuItem>
          </Menu>
        </div>
        <div class="approve-container container-right" style="overflow: auto">
          <router-view></router-view>
        </div>
      </div>
    </TopMain>

    <Modal v-model="modal1" title="修改密码" @on-ok="submit" :mask-closable="false" width="400">
      <div class="register">
        <Form ref="formValidate" :model="form" :label-width="100">
          <FormItem label="请输入旧密码" prop="oldpassword">
            <Input v-model="form.oldpassword" type="password" placeholder="请输入旧密码"></Input>
          </FormItem>
          <FormItem label="请输入新密码" prop="newpassword">
            <Input v-model="form.newpassword" type="password" placeholder="请输入新密码"></Input>
          </FormItem>
          <FormItem label="请确认新密码" prop="newpassword2">
            <Input v-model="form.newpassword2" type="password" placeholder="请确认新密码"></Input>
          </FormItem>
        </Form>
      </div>
    </Modal>

  </div>
</template>

<script>
import LeftRight from '@/public/layout/LeftRight'
import TopMain from '@/public/layout/TopMain'

export default {
  components: {LeftRight, TopMain},
  data() {
    return {
      modal1: false,
      form: {}
    }
  },
  methods: {
    submit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let that = this;
          let data = Object.assign({}, this.form)
          this.$axios({
            url: '/api/user/updatePass',
            method: 'post',
            data: this.$qs.stringify(data)
          }).then(function (rs) {
            that.loading = false;
            if (rs.data.success) {
              that.$Message.success('修改成功,请重新登录');
              that.modal1 = false;
              that.$storage.removeSession('uid');
              that.$storage.removeSession('token');
              //跳转页面
              that.$router.push('/login')
            } else {
              that.toast(rs.data);
              that.modal1 = true;
            }
          });
        } else {
          this.$Message.error('表单验证不通过!');

        }
      });
    },
    reurl(url) {
      this.$router.push({path: url});
    },
    loginout(name) {
      if (name === 'loginout') {
        this.$storage.removeSession('uid');
        this.$storage.removeSession('token');
        this.$router.push({path: '/login'});
      }
      if (name === 'updatepassword') {
        this.modal1 = true;
      }
    },
    toast(data) {
      if (data.success) {
        this.$Message.success(data.msg);
      } else {
        this.$Message.error(data.msg);
      }
    },

  },
  created() {
    this.$router.push({path: '/client'});
    this.$Spin.hide();
  },
  beforeCreate() {
    this.$Spin.show();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue